import { get } from 'lodash-es';
import { SHARE_COMMUNITY_MODE } from 'site-modules/shared/constants/price-checker/share-with-community';
// eslint-disable-next-line venom/no-venom-api-calls
import { VenomApi } from 'client/data/api/api-client';
import { EventToolbox } from 'client/utils/event-toolbox';
import { PRICE_CHECKER_EVENTS } from 'site-modules/shared/constants/price-checker';

export const getSharedDealPropsForPriceForm = props => {
  const { isMobile, onChangeDealer } = props;
  const { closestDealers, chartPrices, ratedDealType, selectedDealer, isDealRated, handleShareDeal } =
    props.sharedWithCommunityProps || {};

  if (!closestDealers) {
    return null;
  }

  return {
    closestDealers,
    isDealRated,
    selectedDealer,
    ratedDealType,
    isMobile,
    mode: SHARE_COMMUNITY_MODE.DISPLAY_OPTION_AFTER_RATING,
    userDealerPrice: get(chartPrices, 'userDealerPrice', 0),
    userMsrp: get(chartPrices, 'userMsrp', 0),
    className: 'pb-2_5',
    onChangeDealer,
    handleShareDeal,
  };
};

export const getAdditionalTrackingData = vehicle => ({
  make_id: vehicle.make && vehicle.make.id,
  model_year_id: vehicle.modelYearId,
  model_link_code: vehicle.model && vehicle.model.modelLinkCode,
  submodel_id: vehicle.id,
  type: vehicle.submodels && vehicle.submodels.slug,
  style_id: vehicle.style && vehicle.style.id,
});

export const getInventoryTrackingData = inventory => {
  const vin = get(inventory, 'vin');

  return vin ? { inv_id_list: get(inventory, 'vid'), vin_list: vin } : {};
};

export const submitDeal = ({ vehicle, deal, dealer, isTestDeal, sessionId }) =>
  // eslint-disable-next-line venom/no-venom-api-calls
  VenomApi.fetchJson('/car-buying/crowd-sourced-deals', {
    method: 'POST',
    retries: 0,
    headers: {
      'content-type': 'application/json',
    },
    showAPIError: true,
    body: JSON.stringify({
      dealer: {
        franchiseId: get(dealer, 'id'),
        rooftopId: get(dealer, 'rooftopId'),
        dealerNiceName: get(dealer, 'name'),
        dealerCity: get(dealer, 'address.city'),
        dealerState: get(dealer, 'address.stateCode'),
        dealerZipCode: get(dealer, 'address.zip'),
      },
      vehicle: {
        year: Number(get(vehicle, 'year.year') || get(vehicle, 'year')),
        make: get(vehicle, 'make.name') || get(vehicle, 'makeName'),
        model: get(vehicle, 'model.name') || get(vehicle, 'modelName'),
        trim: get(vehicle, 'style.trimName', ''),
        style: get(vehicle, 'style.name'),
        styleId: get(vehicle, 'style.id') || get(vehicle, 'styleId'),
        vin: get(vehicle, 'vin'),
        msrp: get(vehicle, 'msrp'),
      },
      deal: {
        dealType: 'unspecified',
        sourcePage: get(deal, 'pageName'),
        dealStage: get(deal, 'dealStage', 'pre-purchase'),
        dealerPrice: get(deal, 'dealerPrice'),
        dealRating: get(deal, 'dealType'),
        userZipCode: get(deal, 'zipCode'),
      },
      isTestDeal,
      sessionId,
    }),
  })
    .then(() =>
      EventToolbox.fireCustomEvent(PRICE_CHECKER_EVENTS.SUBMIT, {
        subactionName: 'processed_submit',
      })
    )
    .catch(() =>
      EventToolbox.fireCustomEvent(PRICE_CHECKER_EVENTS.SUBMIT, {
        subactionName: 'failed_submit',
      })
    );
